<template>
  <div>
    <TopNavbar />
  </div>
</template>

<script>
import TopNavbar from './Navbar_Top.vue';

export default {
  components: {
    TopNavbar,
  },
};
</script>
